<template>
    <div>
        <div ref="richmarker">
            <slot />
        </div>
    </div>
</template>
<script>
    // RichMarker based on https://github.com/xkjyeah/vue-google-maps/issues/209
    import RichMarker from 'googlemaps-rich-marker-web';

    export default {
        props: {
            marker: {
                type: Object,
                required: true,
            },
        },
        mounted() {
            this.createMarker();
        },
        methods: {
            createMarker() {
                this.$parent.$parent.$mapPromise.then(map => {
                    new RichMarker.RichMarker({
                        position: new google.maps.LatLng(this.marker.position.lat, this.marker.position.lng),
                        map: map,
                        draggable: false,
                        flat: true,
                        anchor: RichMarker.RichMarkerPosition.TOP_LEFT,
                        content: this.$refs.richmarker,
                        id: this.marker.id,
                        title: this.marker.name,
                    });
                });
            },
        },
    };
</script>